import dom from '../../wrapper/DomWrapper';
import {
  cancelAnimFrame, easeInOutCubic, requestAnimFrame, scrollTop,
} from './utils';

let button = null;
let scrollY = 0;
let containerHeight = 0;
const minScrollFactor = 0.5;

function animateScroll() {
  const el = dom.window;
  const start = scrollY;
  const distance = -scrollY;
  const duration = 400;

  let timeStart;
  let timeElapsed;
  let frameId;
  let initialFrameId;
  let cancelled;

  const handleUserScroll = () => {
    el.removeEventListener('wheel', handleUserScroll);
    el.removeEventListener('touchmove', handleUserScroll);
    cancelAnimFrame(frameId);
    cancelAnimFrame(initialFrameId);
    cancelled = true;
  };

  dom.on(el, 'wheel', handleUserScroll);
  dom.on(el, 'touchmove', handleUserScroll);

  const end = () => scrollTop(start + distance);

  const loop = (time) => {
    if (cancelled) return;

    timeElapsed = time - timeStart;
    const offset = easeInOutCubic(timeElapsed, start, distance, duration);
    scrollTop(offset);

    if (timeElapsed < duration) {
      frameId = requestAnimFrame(loop);
      return;
    }

    end();
  };

  initialFrameId = requestAnimFrame((time) => {
    timeStart = time;
    loop(time);
  });
}

const isVisible = () => scrollY > containerHeight * minScrollFactor;

const onScroll = () => {
  scrollY = dom.window.pageYOffset;
  containerHeight = dom.window.innerHeight;

  if (isVisible()) {
    dom.addClass(button, 'back-to-top_visible');
  } else {
    dom.removeClass(button, 'back-to-top_visible');
  }
};

const BackToTop = () => {
  button = dom.getElement('.back-to-top');

  if (!button) return;

  scrollY = dom.window.pageYOffset;
  containerHeight = dom.window.innerHeight;

  if (isVisible()) dom.addClass(button, 'back-to-top_visible');

  scrollY = dom.window.scrollY;
  containerHeight = dom.window.innerHeight;
  dom.on(button, 'click', animateScroll);
  dom.on(dom.document, 'scroll', onScroll);
};

export default BackToTop;
